import { computed } from 'vue'
import { useMerchantCreationBlocked } from '@/features/billing/composables/useMerchantCreationBlocked'
import { useSubscribedProducts } from '@/features/billing/composables/useSubscribedProducts'

/**
 * Whether merchants are blocked even though the selected organization has a product: its White Label
 * trial is on hold until its first website request.
 */
export function useWhiteLabelTrialOnHold() {
  const merchantCreationBlocked = useMerchantCreationBlocked()
  const products = useSubscribedProducts()

  return computed(() => merchantCreationBlocked.value && (products.value?.length ?? 0) > 0)
}
